'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mk_MK = require('../locale/mk_MK');

var _mk_MK2 = _interopRequireDefault(_mk_MK);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _mk_MK2['default'];